var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"table",attrs:{"size":"mini","border":"inner","resizable":"","auto-resize":"","highlight-hover-row":"","loading":_vm.loading,"data":_vm.tableData,"columns":_vm.columns,"height":_vm.tableHeight,"toolbar-config":{ slots: { buttons: 'toolbar_form' } },"seq-config":{ startIndex: (_vm.tablePage.curPage - 1) * _vm.tablePage.pageSize },"row-id":"userCode","radio-config":!_vm.multiple
        ? {
            trigger: 'row',
            highlight: _vm.highlight,
            strict: false,
            reserve: _vm.reserve,
          }
        : {},"checkbox-config":_vm.multiple
        ? {
            trigger: 'row',
            highlight: _vm.highlight,
            reserve: _vm.reserve,
          }
        : {}},on:{"radio-change":_vm.radioChange,"checkbox-change":_vm.checkboxChange,"checkbox-all":_vm.checkboxChange},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_vm._t("header")]},proxy:true},{key:"pager",fn:function(){return [_vm._t("pager")]},proxy:true},{key:"empty",fn:function(){return [_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":"/image/static/img/nodata.png"}}),_c('p',{staticClass:"m-0 mt-2"},[_vm._v(" "+_vm._s(_vm.$l("INDEX.table_label_empty") || "暂无数据！")+" ")])])]},proxy:true}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }